import { endpoint } from '../utils/fetching';

interface CitationParams {
  style?: 'apa';
  lang?: 'en-US';
  doi: string;
}

export const CITATION_FORMAT_REFERENCE = endpoint({
  server: 'CITATION',
  path: 'format',
  params: {} as CitationParams,
  schema: '',
});
